import React from 'react'

import { Box, Card } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints, props }) => ({
    root: {
      transition: 'filter 0.2s',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      '&:hover': {
        filter: 'drop-shadow(0px 10px 10px #CCC9CF)'
      }
    },
    card: {
      display: 'flex',
      clipPath: cardShape,
      flexDirection: 'column',
      gridGap: 10,
      justifyContent: 'space-between',
      borderRadius: 0,
      width: '100%',
      height: '100%',
      padding: 16
    },
    edge: {
      width: '100%',
      height: '100%',
      padding: 1,
      clipPath: cardShape,
      backgroundColor: palette.grey.shade[20]
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'row',
      gridGap: 20
    }
  })
)

const cardShape = 'polygon(0% 25px, 25px 0%, 100% 0%, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0% 100%)'

const SkillBiteCardContainer = ({ children, dataTest, onClick, ...props }) => {
  const classes = useStyles(props)
  return (
    <Box
      className={classes.root}
      data-test={dataTest}
    >
      <Box className={classes.edge}>
        <Card variant='elevation' classes={{ root: classes.card }} onClick={onClick}>
          {children}
        </Card>
      </Box>
    </Box>
  )
}

export default SkillBiteCardContainer
